// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface Create2dFloodModelOutput
 */
export interface Create2dFloodModelOutput {
  /**
   *
   */
  schematisation: RanaFile;
}

/**
 * Check if a given object implements the Create2dFloodModelOutput interface.
 */
export function instanceOfCreate2dFloodModelOutput(
  value: object
): value is Create2dFloodModelOutput {
  if (!("schematisation" in value) || value["schematisation"] === undefined) return false;
  return true;
}

export function Create2dFloodModelOutputFromJSON(json: any): Create2dFloodModelOutput {
  return Create2dFloodModelOutputFromJSONTyped(json, false);
}

export function Create2dFloodModelOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Create2dFloodModelOutput {
  if (json == null) {
    return json;
  }
  return {
    schematisation: RanaFileFromJSON(json["schematisation"]),
  };
}

export function Create2dFloodModelOutputToJSON(json: any): Create2dFloodModelOutput {
  return Create2dFloodModelOutputToJSONTyped(json, false);
}

export function Create2dFloodModelOutputToJSONTyped(
  value?: Create2dFloodModelOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    schematisation: RanaFileToJSON(value["schematisation"]),
  };
}
